import React, { useEffect, useState } from "react";
import SideBar from "../Components/SideBar";
import TextEditor from "../Components/textEditor";
import MediaPicker from "../Components/mediaPicker";
import GetAboutUsData, { PostAboutUsData } from "../callApi/aboutUs";
import { fileUpload } from "../../fileUpload";
import config from "../Config.json";
import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";
import SaveButton from "../Components/AdminButtons";
import { toast } from "react-hot-toast";
import IsActive from "../Components/AdminisActive";

export default function AdminAboutUs() {
  const [data, setData] = useState({
    ShowInWebSite: 0,
    cards: Array.from({ length: 4 }, () => ({
      title: "",
      image: { file: "", image: "", status: "none" },
    })),
    featureImage: { status: "none", image: "", file: "" },
    featureImage1: { status: "none", image: "", file: "" },
    content: "",
    sectionAHtmlContent: "",
    sectionCVideo: { url: "", status: "none" },
  });

  const dispatch = useDispatch();

  const isEmpty = () => {
    return data.cards.every((card) => card.title !== "" && card.image.file !== "");
  };

  const handleSave = async () => {
    dispatch(setLoading(true));

    try {
      if (data.content !== "" && data.sectionAHtmlContent !== "" && isEmpty()) {
        let media = {
          featureImage: data.featureImage.file,
          featureImage1: data.featureImage1.file,
          cardImages: data.cards.map((card) => card.image.file),
        };

        let updatedImages = [];

        data.cards.forEach((card) => {
          if (card.image.status === "updated" && card.image.file !== null) {
            updatedImages.push(card.image);
          }
        });

        if (data.featureImage.status === "updated" && data.featureImage.file) {
          updatedImages.push(data.featureImage);
        }

        if (data.featureImage1.status === "updated" && data.featureImage1.file) {
          updatedImages.push(data.featureImage1);
        }

        if (updatedImages.length > 0) {
          const uploadImageRes = await fileUpload(updatedImages);

          if (uploadImageRes.length > 0) {
            media = {
              featureImage:
                data.featureImage.status === "updated"
                  ? uploadImageRes.find((x) => x.fileName === data.featureImage.file.name)?.key
                  : data.featureImage.file,
              featureImage1:
                data.featureImage1.status === "updated"
                  ? uploadImageRes.find((x) => x.fileName === data.featureImage1.file.name)?.key
                  : data.featureImage1.file,
              cardImages: data.cards.map((card, index) => {
                if (card.image.status === "updated") {
                  return uploadImageRes.find((x) => x.fileName === card.image.file.name)?.key;
                } else {
                  return card.image.file;
                }
              }),
            };
          }
        }
        saveData(media);
      } else {
        toast.error("Please fill all values");
      }
    } catch (error) {
      toast.error("Please Try Again!!!");
    } finally {
      dispatch(setLoading(false));
    }
  };

  const saveData = (media) => {
    const params = {
      content: data.content,
      sectionAHtmlContent: data.sectionAHtmlContent,
      cardTitles: data.cards.map((card) => card.title),
      sectionCVideo: data.sectionCVideo ? data.sectionCVideo.url : "",
      media: media,
      ShowInWebSite: data.ShowInWebSite,
    };

    PostAboutUsData(params)
      .then((res) => {
        if (res) {
          toast.success("Data saved successfully");
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        toast.error("Error saving data. Please try again!");
        console.error("Error saving data:", error);
      });
  };

  useEffect(() => {
    dispatch(setLoading(true));

    GetAboutUsData()
      .then((res) => {
        console.log(res, "rt")
        setData((prevData) => ({
          ...prevData,
          content: res.content !== undefined ? res.content : prevData.content,
          sectionAHtmlContent: res.sectionAHtmlContent !== undefined ? res.sectionAHtmlContent : prevData.sectionAHtmlContent,
          cards: res.cardData.map((card) => ({
            title: card.cardName,
            image: {
              file: card.cardImage,
              image: config.awsMediaPath + card.cardImage,
              status: "none",
            },
          })),
          featureImage: {
            status: "none",
            image: config.awsMediaPath + res.featureImage,
            file: res.featureImage,
          },
          featureImage1: {
            status: "none",
            image: config.awsMediaPath + res.featureImage1,
            file: res.featureImage1,
          },
          sectionCVideo: res.sectionCVideo
            ? {
                ...prevData.sectionCVideo,
                ...res.sectionCVideo,
                url: res.sectionCVideo,
              }
            : { ...prevData.sectionCVideo, url: "", status: "none" },
          ShowInWebSite: res.ShowInWebSite !== undefined ? res.ShowInWebSite : prevData.ShowInWebSite,
        }));

        dispatch(setLoading(false));
      })
      .catch((error) => {
        console.error("Error calling about us API:", error);
        toast.error("Error fetching data. Please try again!");
        dispatch(setLoading(false));
      });
  }, [dispatch]); 


  const handleChange = () => {
    setData((prevData) => ({
      ...prevData,
      ShowInWebSite: prevData.ShowInWebSite ? 0 : 1,
    }));
  };

  return (
    <div className="admin-about-us">
      <SideBar />
      <div className="admin-container">
        {data && (
          <div className="sec">
            <h1>About us</h1>
            <div className="sec">
              <div className="about-first-image">
                <MediaPicker
                  type="image"
                  onChange={(file, image) => {
                    setData({
                      ...data,
                      featureImage: {
                        ...data.featureImage,
                        file,
                        image,
                        status: "updated",
                      },
                    });
                  }}
                  source={data.featureImage.image}
                  text="Feature image"
                />
              </div>
            </div>
            <div className="sec">
              <h2>Content</h2>
              <TextEditor
                onChange={(text) => setData((prevData) => ({ ...prevData, content: text }))}
                value={data.content}
              />
            </div>
            <div className="sec">
              <h2>Why to choose?</h2>
              <div style={{ display: "flex", gap: "20px" }}>
                <div className="about-second-image">
                  <MediaPicker
                    type="image"
                    onChange={(file, image) => {
                      setData({
                        ...data,
                        featureImage1: {
                          ...data.featureImage1,
                          file,
                          image,
                          status: "updated",
                        },
                      });
                    }}
                    source={data.featureImage1.image}
                    text="Feature image"
                  />
                </div>
                <div className="about-second-image" style={{ width: "100%" }}>
                  <textarea
                    id="about_html_content"
                    className="materialize-textarea"
                    style={{
                      height: 200,
                      resize: "none",
                      width: "100%",
                      border: "1px solid #d9d9d9",
                    }}
                    onChange={(e) =>
                      setData((prevData) => ({ ...prevData, sectionAHtmlContent: e.target.value }))
                    }
                    value={data.sectionAHtmlContent}
                  />
                  <label htmlFor="about_html_content">HTML Content</label>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  border: "1px solid #d9d9d9",
                  flexWrap: "wrap",
                }}
              >
                {data.cards.map((card, index) => (
                  <div key={index} className="admin-about-cards">
                    <div className="about-card-image">
                      <MediaPicker
                        type="image"
                        onChange={(file, image) => {
                          const newCards = [...data.cards];
                          newCards[index].image.file = file;
                          newCards[index].image.image = image;
                          newCards[index].image.status = "updated";
                          setData((prevData) => ({ ...prevData, cards: newCards }));
                        }}
                        source={card.image.image}
                        text="Card image"
                      />
                    </div>
                    <div className="input-field">
                      <input
                        type="text"
                        className="validate"
                        onChange={(e) => {
                          const newCards = [...data.cards];
                          newCards[index].title = e.target.value;
                          setData((prevData) => ({ ...prevData, cards: newCards }));
                        }}
                        value={card.title}
                      />
                      <label>Title</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="sec">
              <h2>Youtube Video</h2>
              <div className="input-field about-youtube">
                <input
                  id="section-g-video"
                  type="text"
                  className="validate"
                  onChange={(e) =>
                    setData((prevData) => ({
                      ...prevData,
                      sectionCVideo: {
                        ...prevData.sectionCVideo,
                        url: e.target.value,
                        status: "updated",
                      },
                    }))
                  }
                  value={data.sectionCVideo ? data.sectionCVideo.url : ""}
                />
                <label>Video URL</label>
              </div>
            </div>
            <div className="input-field">
              <label>
                <span>
                  <IsActive checked={data.ShowInWebSite} onChange={handleChange} />
                </span>
              </label>
            </div>
            <SaveButton onClick={handleSave} />
          </div>
        )}
      </div>
    </div>
  );
}
